export const environment = {
  production: true,
  apiUrl: 'https://us-central1-pagg-i.cloudfunctions.net/api/v1'
};

export const firebaseConfig = {
  apiKey: "AIzaSyAmoZy0NIum91DAaujfADHsqVsuSIdfmnQ",
  authDomain: "pagg-i.firebaseapp.com",
  databaseURL: "https://pagg-i.firebaseio.com",
  projectId: "pagg-i",
  storageBucket: "pagg-i.appspot.com",
  messagingSenderId: "369705893702",
  appId: "1:369705893702:web:c0795c52232e711b28af47"
}

export const algoliaConfig = {
  appId: 'R0EGXSNY6K',
  apiKey: '521484e42ee88d0db1cf244a88347998'
}

export const pusherConfig = {
  key: '034717a5748710ffefc3',
  cluster: 'us2'
}